import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import HeaderLogo from '../header-logo';

const ConsumerSimpleHeader = ({ headerClassNames }) => (
  <header
    data-xc="consumer-simple-header"
    className={classNames(
      'text-center px-0 py-1 [border-bottom:1px_solid_#f6f6f6]',
      {
        [headerClassNames]: !!headerClassNames,
      }
    )}
  >
    <HeaderLogo />
  </header>
);

ConsumerSimpleHeader.propTypes = {
  headerClassNames: PropTypes.string,
};

export default ConsumerSimpleHeader;
